/***
 *
 * Table = fontSmallest & 300
 * Breadcrumbs, input labels = fontSmall & 300
 * Footer links, top bar (help), site name second line = fontSmall & 400
 * Coverage info text, other additional informations = fontMedium & 300
 * Buttons other than CTA = fontSmall & 400
 * First line of site name, text inside inputs, CTA buttons, Start new search button = fontLarge & 400
 * Boxes title = fontXLarge & 400
 *
 */

export const fontSmallest = '13px';
export const fontSmaller = '14px';
export const fontSmall = '16px';
export const fontMedium = '18px';
export const fontLarge = '20px';
export const fontXLarge = '26px';

export const DKVGreen = '#86A315';
export const DKVLightGreen = 'rgba(134, 163, 21, 0.25)';
export const DKVWarmGrey70 = '#96918B';
export const DKVLightGrey = '#D2D0CD';
export const DKVGrey = '#6A625A';
export const DKVBgGrey = '#f0efee';
export const linkBlue = '#4A90E2';
export const red = '#D61627'; //color-picked from validation image in initial designs

export const insurerId = '0739';

export const InputLabelMargin = 10;

export const ADMISSION_NUMBER_MAX_LENGTH = 25;

export const fontFedra = '"Fedra",Verdana,sans-serif';

export const DKVBorder = '1px solid #ddd';

export const LanguageEnum = {
  NL: 'nl',
  FR: 'fr',
  EN: 'en',
  DE: 'de'
};
